export default __webpack_public_path__ + "static/media/empty-calendar-day.4ae66c67.png";